import EnquiryWelcomeContent from './Content';
import useEnquiryWelcome from './useEnquiryWelcome';

const EnquiryWelcome: React.FunctionComponent = function () {
  const props = useEnquiryWelcome();
  return <EnquiryWelcomeContent {...props} />;
};

export default EnquiryWelcome;
